import { FunctionComponent, h } from 'preact';
import { useContext } from 'preact/hooks';

import { ExternalLinkIcon } from '@uw/icons';
import { Icon } from 'components/icon/icon';
import { useTranslation } from 'hooks';
import { ApplicationContext } from 'contexts/use-application-setup';
import { redirectToDashboard } from 'helpers/redirect-to-dashboard';

import './upgrade.scss';

export const Upgrade: FunctionComponent = () => {
  const { translate } = useTranslation();
  const { tunings } = useContext(ApplicationContext);

  const handleRedirect = (event: Event) => {
    event.preventDefault();
    const redirectPath = `/widget/my-sites/p/1/site-details/overview?site=${tunings?.site_name}#pro-widget-plans`;
    redirectToDashboard(redirectPath);
  };

  return (
    <div class="uwaw-upgrade-card">
      <div class="uwaw-upgrade-card__inner">
        <div class="uwaw-upgrade-card__header">
          <div>
            <h2 class="uwaw-upgrade-card__title">{translate('widget.upgrade.title')}</h2>
            <p class="uwaw-upgrade-card__subtitle">{translate('widget.upgrade.description')}</p>
          </div>
          <div class="uwaw-upgrade-card__icon">
            <Icon type="ai-chip-v2" />
          </div>
        </div>

        <div class="uwaw-upgrade-card__footer">
          <a
            href="#"
            role="link"
            target="_blank"
            rel="noopener"
            aria-label="Upgrade Now, opens in a new tab"
            class="uwaw-btn__primary uwaw-upgrade-card__button"
            onClick={handleRedirect}
          >
            <span class="uwaw-upgrade-card__button-label">
              {translate('widget.upgrade.button')}
            </span>
            <ExternalLinkIcon
              className="uwaw-upgrade-card__button-icon"
              height={18}
              width={18}
              svgAttrs={{ 'aria-hidden': 'true', focusable: 'false', width: '18', height: '18' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};
